import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pastel-blue via-white to-pastel-green dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-500 rounded-2xl mb-4">
            <svg className="w-10 h-10 text-white" viewBox="0 0 100 100" fill="none">
              <path d="M20 55 Q35 45 50 55 Q65 65 80 55" stroke="currentColor" strokeWidth="6" strokeLinecap="round"/>
              <path d="M25 65 Q40 55 55 65 Q70 75 85 65" stroke="currentColor" strokeWidth="4" strokeLinecap="round" opacity="0.7"/>
              <ellipse cx="50" cy="38" rx="16" ry="7" fill="currentColor" opacity="0.8"/>
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-slate-900 dark:text-white">Moorly</h1>
          <p className="text-slate-600 dark:text-slate-400 mt-1">Connect on the canals</p>
        </div>
        
        <div className="card p-6">
          <Outlet />
        </div>
        
        <p className="text-center text-sm text-slate-500 dark:text-slate-400 mt-6">
          By continuing, you agree to our Terms of Service and Privacy Policy.
        </p>
      </div>
    </div>
  );
}
